module.exports = __webpack_public_path__ + "img/strategy.b5e5287f.svg";